import { DealerHolidaySaveViewModel, DealerHolidayViewModel } from './../business-entities/dealer-holiday-list-view-model';
import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'

@Injectable({
    providedIn: 'root'
})

export class DealerHolidayDataService {
    constructor(private dataProvider: DataService) {
    }
    async getDealerHolidayList(): Promise<GenericResponse<Array<DealerHolidayViewModel>>> {
        return this.dataProvider.Get<GenericResponse<Array<DealerHolidayViewModel>>>(Urls.GetDealerHolidayList).toPromise();
    }

    async getDealerWiseHolidayList(dealerId: string): Promise<GenericResponse<Array<DealerHolidayViewModel>>> {
        return this.dataProvider.Get<GenericResponse<Array<DealerHolidayViewModel>>>(Urls.GetDealerWiseHolidayList, dealerId).toPromise();
    }

    async getDealerHolidayDetails(dealerHoldiayId: number): Promise<GenericResponse<DealerHolidayViewModel>> {
        return this.dataProvider.Get<GenericResponse<DealerHolidayViewModel>>
        (Urls.DealerHolidayDetails, dealerHoldiayId).toPromise();
    }
    
    addDealerHolidays(dealerServiceViewModel: DealerHolidayViewModel): Promise<GenericResponse<DealerHolidayViewModel>> {
        return this.dataProvider.Post<GenericResponse<DealerHolidayViewModel>>(Urls.AddDealerHoliday, dealerServiceViewModel).toPromise();
    }

    editDealerHolidays(dealerServiceViewModel: DealerHolidaySaveViewModel): Promise<GenericResponse<DealerHolidaySaveViewModel>> {
        return this.dataProvider.Put<GenericResponse<DealerHolidaySaveViewModel>>(Urls.EditDealerHoliday, dealerServiceViewModel).toPromise();
    }

    deleteDealerHoliday(id: number): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteDealerHoliday, id).toPromise();
    }
}